import { useTranslation } from 'react-i18next'

import { selectColor, StatusChip } from 'components/Chips/StatusChip'
import Tooltip from 'components/Tooltip'
import { GamSetupOrderSlice } from 'features/globalSetup/pages/GoogleAdManagerConnectionPage/sections/SetupPrebidStackSection/hooks/useGetGamSetupOrders'
import { GamStatus } from 'features/globalSetup/types/gamStatus'
import { DATE_FORMAT, formatDate } from 'utils/date'

type Props = Partial<{
  gamSetupOrder: GamSetupOrderSlice
  status: GamStatus
}>

export const StatusBadge = ({ gamSetupOrder, status }: Props): JSX.Element => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'googleAdManagerConnection.setupPrebidStack',
  })

  if (gamSetupOrder === undefined || status === undefined) {
    return <></>
  }

  return (
    <Tooltip
      content={
        status === 'completed'
          ? t('form.statusTooltip', {
              updatedAt: formatDate(gamSetupOrder.updatedAt, DATE_FORMAT.WITH_TIME),
            })
          : ''
      }
    >
      <StatusChip
        chipColors={theme => selectColor<GamStatus>(status, theme)}
        status={status}
      />
    </Tooltip>
  )
}
